"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Notification = _ref => {
  let {
    colorClassName,
    iconName,
    status,
    children,
    footer
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "hero is-fullheight"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hero-body has-text-centered"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "notify"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `icon ${colorClassName}`
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, iconName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "notify-status pb-3"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: colorClassName
  }, status)), /*#__PURE__*/_react.default.createElement("div", {
    className: "notify-content"
  }, children), footer && /*#__PURE__*/_react.default.createElement("div", {
    className: "notify-footer pb-3"
  }, footer))))));
};
Notification.propTypes = {
  colorClassName: _propTypes.default.string,
  iconName: _propTypes.default.string,
  status: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  footer: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};
var _default = exports.default = Notification;
//# sourceMappingURL=Notification.js.map